import React, { useMemo } from 'react';

import { Col } from '@opendoor/atoms/box';
import { Navigate, Route, Routes, useLocation } from 'react-router';

import { SIGN_UP_ROUTE } from '../routes';
import { IPageConfig, pages } from './Pages';

type QueryParams = {
  email?: string;
  partnershipType?: string;
  role?: string;
  partnerIdentifier?: string;
};

const SignUp: React.FC = () => {
  const location = useLocation();
  const params: QueryParams = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);

    return {
      email: searchParams.get('email') ?? undefined,
      partnershipType: searchParams.get('partnershipType') ?? undefined,
      role: searchParams.get('role') ?? undefined,
      partnerIdentifier: searchParams.get('partnerIdentifier') ?? undefined,
    };
  }, [location.search]);

  const { email, partnershipType, role, partnerIdentifier } = params;

  const renderRoutes = () => {
    return (
      <Routes>
        <Route
          index
          element={
            <Navigate
              to={`${SIGN_UP_ROUTE}/${pages[0].path}`}
              state={{ email, partnershipType, role, partnerIdentifier }}
              replace
            />
          }
        />
        {pages.map((page: IPageConfig) => (
          <Route key={page.path} path={page.path} element={<page.component />} />
        ))}
      </Routes>
    );
  };

  return <Col className="min-h-screen">{renderRoutes()}</Col>;
};

export default SignUp;
